"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var BaseComponent_1 = require("./base/BaseComponent");
var ko = require("knockout");
var $ = require("jquery");
var _ = require("lodash");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var metrikaUtils_1 = require("../../app/utils/metrikaUtils");
var MobilyLibraryButtonComponent = (function (_super) {
    __extends(MobilyLibraryButtonComponent, _super);
    function MobilyLibraryButtonComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.currentState = ko.observable("None");
        this.popoverName = "libraryBtnPopover";
        this.openPopover = function () {
            app.f7.closeModal();
            app.f7.popover($("#" + _this.popoverName + "-" + _this.workId)[0], $(_this.element)[0]);
        };
        this.stateForPopover = ko.pureComputed(function () {
            var currentState = _this.currentState();
            if (currentState === "None") {
                return { title: "В библиотеку", icon: "icon-plus" };
            }
            return _this.getStateInfo(currentState);
        });
        this.statesToUpdate = ko.pureComputed(function () {
            var currentState = _this.currentState();
            return _.filter(_this.libraryStates, function (s) {
                return s.state !== currentState;
            });
        });
        this.getStateInfo = function (state) {
            return _.find(_this.libraryStates, function (s) {
                return s.state === state;
            });
        };
        this.updateLibraryState = function (state) {
            if (!app.ensureAuth("Чтобы добавить книгу в библиотеку, необходимо авторизоваться")) {
                return;
            }
            var hideButton = window["AppComponents"].MobileHideButton;
            if (_this.processing())
                return;
            _this.processing(true);
            if (hideButton)
                hideButton.processing(true);
            var stateValue = state.state;
            if (stateValue !== "None" && stateValue !== "Disliked") {
                try {
                    metrikaUtils_1.default.reachGoal("addToLibrary", { workId: _this.workId, state: stateValue });
                }
                catch (ex) { }
            }
            app.f7.closeModal($("#" + _this.popoverName + "-" + _this.workId)[0]);
            ajaxUtils_1.AjaxUtils.post("work/updateLibrary", {
                ids: [_this.workId],
                state: stateValue
            }).done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                else {
                    _this.currentState(stateValue);
                    if (hideButton)
                        hideButton.isDisliked(stateValue == "Disliked");
                    if (_this.params.showNotification) {
                        alert("Статус книги в библиотеке был изменен.");
                    }
                }
            }).always(function () {
                _this.processing(false);
                if (hideButton)
                    hideButton.processing(false);
                _this.handleRefreshWorkMetaInfo(app, _this.workId);
            });
        };
        if (params.format === "EBook") {
            this.libraryStates = [
                { state: "Reading", title: "Читаю", icon: "icon-2-library-reading" },
                { state: "Saved", title: "Отложено на потом", icon: "icon-2-clock" },
                { state: "Finished", title: "Прочитано", icon: "icon-2-library-finished" }];
        }
        else if (params.format === "Audiobook") {
            this.libraryStates = [
                { state: "Reading", title: "Слушаю", icon: "icon-2-player-play" },
                { state: "Saved", title: "Отложено на потом", icon: "icon-2-clock" },
                { state: "Finished", title: "Прослушано", icon: "icon-2-library-finished" }];
        }
        (_a = this.libraryStates).push.apply(_a, [
            { state: "Disliked", title: "Не интересно", icon: "icon-eye-slash" },
            { state: "None", title: "Удалить из библиотеки", icon: "icon-cross text-danger" }
        ]);
        this.currentState(params.state);
        this.workId = params.workId;
        this.onlyIcon = params.onlyIcon;
        var _a;
    }
    return MobilyLibraryButtonComponent;
}(BaseComponent_1.default));
ko.components.register("mobile-library-button", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MobilyLibraryButtonComponent;
//# sourceMappingURL=mobileLibraryButton.js.map